import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import FormProvider from 'common/components/form-provider';
import React from 'react';
import { useForm } from 'react-hook-form';
import { colors } from 'common/constants';
import ImgVnpay from 'assets/images/icons/campaign-data-collection/payment-vnpay.jpg';
import ModalConfirm from 'common/components/modal-confirm';
import { useAppDispatch, useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { CreatePayment } from 'services/payment.service';
import { toast } from 'react-toastify';
import { handleError } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
import { clearCampaign } from 'slices/campaignsSlice';

interface IPaymentProps {
    tabIndex: number;
}
const Payment: React.FC<IPaymentProps> = () => {
    const surveyPayment = useAppSelector(
        (state: RootState) => state.payment.surveyPayment
    );
    const campaign = useAppSelector(
        (state: RootState) => state.campaignState.campaign
    );
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const methods = useForm();
    const { handleSubmit } = methods;
    const [openModalRequestPrice, setOpenModalRequestPrice] =
        React.useState(false);

    const onSubmit = handleSubmit(async () => {
        if (!surveyPayment.product_id) {
            toast.error('Hãy hoàn thành bước 1 trước');
            return;
        }
        try {
            const payment_target_payload = {
                dob: surveyPayment.payment_target.dob,
                gender: surveyPayment.payment_target.gender,
                address: surveyPayment.payment_target.address,
                marriage: surveyPayment.payment_target.marriage,
                child: surveyPayment.payment_target.child,
                career: surveyPayment.payment_target.career,
                career_field: surveyPayment.payment_target.career_field,
                monthly_personal_income:
                    surveyPayment.payment_target.monthly_personal_income,
                monthly_family_income:
                    surveyPayment.payment_target.monthly_family_income,
            };
            const payload = {
                payment: {
                    product_type: surveyPayment.product_type,
                    product_id: surveyPayment.product_id,
                    total_answer: surveyPayment.costInfo.number_of_answer,
                    client_company_name: surveyPayment.invoiceInfo.companyName,
                    client_tax_number: surveyPayment.invoiceInfo.taxCode,
                    client_company_address: surveyPayment.invoiceInfo.address,
                    client_name: surveyPayment.invoiceInfo.invoiceRecipient,
                    client_phone: surveyPayment.invoiceInfo.phone,
                    client_email: surveyPayment.invoiceInfo.email,
                    payment_target: payment_target_payload,
                },
            };
            const response = await CreatePayment(payload);
            if (response.success) {
                const responseAttributes = response.data.payment.attributes;
                if (responseAttributes) {
                    dispatch(clearCampaign());
                    localStorage.setItem(
                        'urlCallback',
                        `/admin/campaign/data-collect/${campaign?.id}/payment-results`
                    );
                    window.open(responseAttributes.url_payment, '_blank');
                    navigate(
                        `/admin/campaign/data-collect/${surveyPayment.product_id}/payment-results`
                    );
                }
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    });

    return (
        <Box sx={{ marginTop: 5 }}>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={11}>
                    <Grid item xs={7}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                fontSize: '30px',
                                lineHeight: '36px',
                                marginBottom: '26px',
                            }}
                        >
                            Chọn phương thức thanh toán
                        </Typography>
                        <img
                            src={ImgVnpay}
                            alt="vnpay"
                            style={{
                                borderRadius: '30px',
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '20px',
                                lineHeight: '28px',
                                fontWeight: 300,
                                marginTop: '44px',
                                fontStyle: 'italic',
                            }}
                        >
                            Nhấn nút Thanh toán bên phải, bạn sẽ được chuyển đến
                            công thanh toán trực tuyến của VNPAY - Đối tác thanh
                            toán của Surveytrue.vn. Tại đây giao dịch của bạn sẽ
                            được bảo vệ một cách an toàn nhất. Khảo sát của bạn
                            sẽ được hệ thống tự động kích hoạt ngay sau khi
                            thanh toán thành công.
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 400,
                                fontSize: '50px',
                                lineHeight: '60.51px',
                            }}
                        >
                            Hóa đơn
                        </Typography>
                        <Divider
                            sx={{
                                borderTop: '2px dashed #000',
                                margin: '20px 0px 51px 0px',
                            }}
                        />
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: '50px',
                                fontWeight: 600,
                                lineHeight: '35px',
                                marginBottom: '12px',
                            }}
                        >
                            {surveyPayment.costInfo.total_price_text}
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: '24px',
                                lineHeight: '35px',
                                fontWeight: 400,
                                marginBottom: '43px',
                            }}
                        >
                            Tổng chi phí VND
                        </Typography>
                        <Box>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    width: '100%',
                                    marginBottom: '39px',
                                    minHeight: '60px',
                                    borderRadius: '60px',
                                    fontSize: '24px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                }}
                            >
                                Thanh toán
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => setOpenModalRequestPrice(true)}
                                sx={{
                                    width: '100%',
                                    marginBottom: '60px',
                                    minHeight: '60px',
                                    borderRadius: '60px',
                                    fontSize: '24px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    backgroundColor: '#FF7916',
                                    '&:hover': {
                                        backgroundColor: '#FF7916',
                                    },
                                }}
                            >
                                Yêu cầu bảng giá
                            </Button>
                        </Box>
                        <Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '30px',
                                    fontWeight: 600,
                                    lineHeight: '36.31px',
                                    marginBottom: '12px',
                                }}
                            >
                                Ngày hoàn thành
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: '24px',
                                    fontWeight: 400,
                                    lineHeight: '29.05px',
                                    marginBottom: '59px',
                                    color: '#000000B2',
                                }}
                            >
                                {surveyPayment.costInfo.date_payment}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, 1fr)',
                                gap: 2,
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '30px',
                                    fontWeight: 600,
                                    lineHeight: '36.31px',
                                }}
                            >
                                Chi tiết
                            </Typography>
                            <Box />

                            {[
                                {
                                    label: 'Số lượng câu hỏi',
                                    value: surveyPayment.costInfo
                                        .number_of_question,
                                    icon: '1',
                                },
                                {
                                    label: 'Chi phí một câu hỏi',
                                    value: `${surveyPayment.costInfo.base_price_text} VND`,
                                    icon: '2',
                                },
                                {
                                    label: 'Số người tham gia',
                                    value: surveyPayment.costInfo
                                        .number_of_answer,
                                    icon: '3',
                                },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontSize: '24px',
                                            fontWeight: 400,
                                            lineHeight: '29.05px',
                                            color: '#000000B2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                        }}
                                    >
                                        {item.label}
                                        {item.icon && (
                                            <Box
                                                sx={{
                                                    width: '20px',
                                                    height: '20px',
                                                    backgroundColor:
                                                        colors.main,
                                                    fontSize: '12px',
                                                    color: '#fff',
                                                    borderRadius: '50%',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    fontWeight: 700,
                                                }}
                                            >
                                                {item.icon}
                                            </Box>
                                        )}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontSize: '24px',
                                            fontWeight: 400,
                                            lineHeight: '29.05px',
                                            textAlign: 'right',
                                            color: '#000000B2',
                                        }}
                                    >
                                        {item.value}
                                    </Typography>
                                </React.Fragment>
                            ))}
                        </Box>

                        <Divider
                            sx={{
                                borderTop: '2px dashed #000',
                                margin: '20px 0px 51px 0px',
                            }}
                        />
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, 1fr)',
                                gap: 2,
                            }}
                        >
                            <Box></Box>
                            <Box
                                sx={{
                                    fontSize: '24px',
                                    fontWeight: 400,
                                    lineHeight: '29.05px',
                                    color: '#000000B2',
                                    textAlign: 'right',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    gap: 1,
                                }}
                            >
                                Chi phí =
                                {[1, 2, 3].map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 1,
                                        }}
                                    >
                                        <Box
                                            key={index}
                                            sx={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: colors.main,
                                                fontSize: '12px',
                                                color: '#fff',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {item}
                                        </Box>
                                        {index < [1, 2, 3].length - 1 && (
                                            <span
                                                style={{
                                                    fontSize: '12px',
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {' '}
                                                X
                                            </span>
                                        )}
                                    </Box>
                                ))}
                            </Box>
                            {[
                                {
                                    label: 'Tổng tiền',
                                    value: `${surveyPayment.costInfo.price_before_discount_text} VND`,
                                },
                                {
                                    label: 'Chiết khấu',
                                    value: `${surveyPayment.costInfo.discount_text} VND`,
                                },
                                {
                                    label: 'Tổng chi phí trước thuế',
                                    value: `${surveyPayment.costInfo.price_before_tax_text} VND`,
                                },
                                {
                                    label: 'VAT (10%)',
                                    value: `${surveyPayment.costInfo.tax_text} VND`,
                                },
                            ].map((item, index) => (
                                <React.Fragment key={index}>
                                    <Box
                                        sx={{
                                            fontSize: '24px',
                                            fontWeight: 400,
                                            lineHeight: '29.05px',
                                            color: '#000000B2',
                                        }}
                                    >
                                        {item.label}
                                    </Box>
                                    <Box
                                        sx={{
                                            fontSize: '24px',
                                            fontWeight: 400,
                                            lineHeight: '29.05px',
                                            color: '#000000B2',
                                            textAlign: 'right',
                                        }}
                                    >
                                        {item.value}
                                    </Box>
                                </React.Fragment>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </FormProvider>
            <ModalConfirm
                open={openModalRequestPrice}
                onClose={() => setOpenModalRequestPrice(false)}
                onOk={() => setOpenModalRequestPrice(false)}
                title="Dịch vụ khảo sát"
                textOk="Xác nhận"
                textClose=""
                content={
                    <Box
                        sx={{
                            fontSize: '24px',
                        }}
                    >
                        Vui lòng liên hệ <b>support@surveytrue.vn</b> hoặc qua
                        hotline <b>0812.122.xxx</b> để được hướng dẫn và nhận
                        báo giá.
                    </Box>
                }
            />
        </Box>
    );
};

export default Payment;
